export default {
  title: 'Willkommen auf LAYA',
  subtitle: 'der inklusiven Lernplattform',
  promoText1: 'Wir bieten Lernkurse zu aktuellen Themen wie Burnout und Compliance für Schüler mit Lernschwächen oder sensorischen Einschränkungen.<br>Unsere Inhalte gibt es auch in einfacher Sprache.',
  promoText2: 'Für Schüler mit Hör- oder Sehschwächen bieten wir unsere Inhalte sowohl in Audio- als auch in Videoform an.<br>Unsere Videos werden durch Gebärdensprache begleitet.',
  promoText3: 'Unsere Seite ist für die Navigation mit der Tastatur optimiert und durch die Benutzung eines Screen-Readers getestet.',

  register: 'Melde Dich an!'
}



// WEBPACK FOOTER //
// ./src/i18n/root/de.js